// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2HlWj","rootSuccess":"CompleteLink_rootSuccess__wfwRY","rootFailure":"CompleteLink_rootFailure__3utT_","isDisabled":"CompleteLink_isDisabled__2Kxr8"};